






























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import MediaList from '@/modules/media/components/shared/MediaList.vue'

const defaultFormats = [
  '.jpg',
  '.jpeg',
  '.bmp',
  '.png',
  '.html',
  '.txt',
  '.docx',
  '.doc',
  '.xls',
  '.csv',
  '.zip',
  '.rar',
  '.pdf'
]

@Component({
  components: {
    BaseButton,
    MediaList
  }
})
export default class MediaUploader extends Vue {
  @Prop({ required: true, default: () => [] }) value: Array<File | MediaResourceModel>
  @Prop({ default: 3 }) maxFiles: number
  @Prop({ default: 'box' }) type: 'box' | 'button'
  @Prop({ default: () => defaultFormats }) formats: typeof defaultFormats
  @Prop({ default: ' فایل ضمیمه' }) buttonLabel: string
  @Prop({ default: () => ({}) }) listProps: object
  @Prop({ default: true }) multiple: boolean
  @Prop({ default: true }) deletable: boolean
  @Prop() label: string

  $refs: {
    uploader: any
  }

  get boxLabel() {
    return this.$q.screen.lt.md
      ? 'جهت آپلود ضربه بزنید'
      : 'جهت آپلود ضربه بزنید یا فایل را اینجا رها کنید'
  }

  get isTypeBox() {
    return this.type === 'box'
  }

  get acceptFormats() {
    return this.formats
      .map(format => format.charAt(0) === '.' ? format : `.${format}`)
      .join(',')
  }

  protected get uploaderAttributes() {
    if (this.type === 'button') {
      return {
        class: 'full-width no-shadow tes-button-uploader',
        accept: this.acceptFormats
      }
    }

    return {
      ...this.$attrs,
      'text-color': 'tes-blue',
      class: 'tes-uploader full-width bg-tes-blue-light text-tes-blue ',
      color: 'tes-blue-light',
      flat: true,
      accept: this.acceptFormats,
      bordered: true
    }
  }

  get addButtonAttributes() {
    if (this.type === 'button') {
      return {
        'text-color': 'white',
        'button-class': 'bg-tes-navy-blue-dark q-px-md',
        unelevated: true,
        color: 'tes-navy-blue-dark',
        dense: false,
        type: 'button'
      }
    }

    return {
      'text-color': 'tes-navy-blue-dark',
      'button-class': 'q-px-md no-hover',
      unelevated: true,
      dense: true,
      type: 'a'
    }
  }

  @Watch('value', { immediate: true })
  onChangeValue() {
    if (this.$refs.uploader) {
      this.setFiles()
    } else {
      this.$nextTick(this.setFiles)
    }
  }

  setFiles(value?) {
    if (value) {
      this.$refs.uploader.files = this.addKey(value)
      this.$refs.uploader.queuedFiles = this.addKey(value)
      this.fileChange()
    } else {
      this.$refs.uploader.files = this.addKey(this.value)
    }
  }

  addKey(value) {
    return value.map(v => {
      const randomId = Math.random().toString().replace('0.', 'x')
      Reflect.defineProperty(v, '__key', { value: randomId })
      return v
    })
  }

  showHeader(filesLength: number) {
    return (filesLength > 0) && (filesLength < this.maxFiles)
  }

  fileChange() {
    const files = this.$refs.uploader.files
    this.$refs.uploader.dnd = false
    this.$emit('input', files)
  }
}
